// extracted by mini-css-extract-plugin
module.exports = {"xAxis":"lineChart_xAxis__2S2XA","yAxis":"lineChart_yAxis__MJWHm"};